export default __webpack_public_path__ + "static/Contact-d9c4bd97426f85b5c0a2cb029771ff94.png";